jQuery(document).ready(function ($) {


    window.dataLayer = window.dataLayer || [];
    // Get the URL parameter from the main page
    const urlParams = new URLSearchParams(window.location.search);
    const popped = urlParams.get('popped');
    const step = urlParams.get('step');

    // Define Data Storage
    const BuilderStorage = {
        // Add a new property to track initialization state
        _freshInit: true,

        set: function (key, value) {
            localStorage.setItem(key, JSON.stringify(value));
            // When actively setting a value, it's no longer a fresh init
            this._freshInit = false;
        },

        get: function (key) {
            const item = localStorage.getItem(key);
            // If we successfully get a non-null value, it's no longer a fresh init
            if (item !== null) {
                this._freshInit = false;
            }
            return item ? JSON.parse(item) : null;
        },

        init: function () {
            // Check if storage is empty before initialization
            const isEmpty = !localStorage.getItem('currentStep') &&
                !localStorage.getItem('siteEmulated') &&
                !localStorage.getItem('industry') &&
                !localStorage.getItem('industryDescription') &&
                !localStorage.getItem('description') &&
                !localStorage.getItem('topics') &&
                !localStorage.getItem('selectedTopics') &&
                !localStorage.getItem('suggestedDomains') &&
                !localStorage.getItem('domainTldData') &&
                !localStorage.getItem('desiredLength') &&
                !localStorage.getItem('preferredLanguage') &&
                !localStorage.getItem('categoryKey');

            // Initialize with default values if not set
            if (!this.get('currentStep')) this.set('currentStep', 1);
            if (!this.get('siteEmulated')) this.set('siteEmulated', '');
            if (!this.get('industry')) this.set('industry', '');
            if (!this.get('industryDescription')) this.set('industryDescription', '');
            if (!this.get('description')) this.set('description', '');
            if (!this.get('topics')) this.set('topics', []);
            if (!this.get('selectedTopics')) this.set('selectedTopics', []);
            if (!this.get('suggestedDomains')) this.set('suggestedDomains', []);
            if (!this.get('domainTldData')) this.set('domainTldData', {});
            if (!this.get('desiredLength')) this.set('desiredLength', 10);
            if (!this.get('preferredLanguage')) this.set('preferredLanguage', 'English');
            if (!this.get('categoryKey')) this.set('categoryKey', '');

            // Set _freshInit based on whether storage was empty before initialization
            this._freshInit = isEmpty;
        },

        isFreshInit: function () {
            return this._freshInit;
        },

        reset: function () {
            // Reset all values to their defaults without clearing localStorage
            this.set('currentStep', 2);
            // this.set('siteEmulated', '');
            this.set('industry', '');
            this.set('industryDescription', '');
            this.set('description', '');
            this.set('topics', []);
            this.set('selectedTopics', []);
            this.set('suggestedDomains', []);
            this.set('domainTldData', {});
            this.set('desiredLength', 10);
            this.set('preferredLanguage', 'English');
            this.set('categoryKey', '');

            // Reset is an active operation, so it's no longer a fresh init
            this._freshInit = false;
        },

        clear: function () {
            // Clear all builder-related items from localStorage
            localStorage.removeItem('currentStep');
            localStorage.removeItem('siteEmulated');
            localStorage.removeItem('industry');
            localStorage.removeItem('industryDescription');
            localStorage.removeItem('description');
            localStorage.removeItem('topics');
            localStorage.removeItem('selectedTopics');
            localStorage.removeItem('suggestedDomains');
            localStorage.removeItem('domainTldData');
            localStorage.removeItem('desiredLength');
            localStorage.removeItem('preferredLanguage');
            localStorage.removeItem('categoryKey');

            // Reinitialize with defaults
            this.init();

            // Return to step 1
            changeStep(1);
        }
    };

    const setPopunderCookie = () => {
        const expiry = new Date();
        expiry.setTime(expiry.getTime() + 600000); // 10 minutes expiry
        document.cookie = `popunder_shown=yes; expires=${expiry.toUTCString()}; path=/`;
    };

    const hasPopunderCookie = () => {
        return document.cookie.includes('popunder_shown=yes');
    };

    const generateDomainIdeas = async function (industry, selectedTopics) {
        try {
            const token = await RecaptchaHelper.execute('generate_domains');

            AnalyticsHelper.trackBizTopicsSelected(selectedTopics);

            return new Promise((resolve, reject) => {
                $.ajax({
                    url: craftrtech_ajax.ajax_url,
                    type: 'POST',
                    data: {
                        action: 'craftrtech_domain_ideas',
                        industry: industry,
                        selected_topics: selectedTopics,
                        description: BuilderStorage.get('description'),
                        recaptcha_token: token,
                        _ajax_nonce: craftrtech_ajax.nonce
                    },
                    success: function (response) {
                        if (response.success) {
                            // Store domain ideas
                            BuilderStorage.set('suggestedDomains', response.data.domain_ideas);
                            BuilderStorage.set('currentStep', 4);
                            resolve(response.data);
                        } else {
                            ErrorHandler.log('Step 3', response?.data?.message || 'Failed to generate domain ideas', {
                                industry: industry,
                                selectedTopics: selectedTopics
                            });
                            reject(new Error(response?.data?.message || 'Failed to generate domain ideas. Please try again.'));
                        }
                    },
                    error: function (xhr, status, error) {
                        ErrorHandler.log('Step 3', error, {
                            industry: industry,
                            selectedTopics: selectedTopics,
                            status: status,
                            xhr: xhr.responseText
                        });
                        reject(new Error('An error occurred while generating domain ideas. Please try again.'));
                    }
                });
            });
        } catch (error) {
            ErrorHandler.log('Step 3', error, {
                industry: industry,
                selectedTopics: selectedTopics
            });
            throw new Error('An error occurred while processing your request. Please try again.');
        }
    };

    // Error Handler Object
    const ErrorHandler = {
        log: function (step, error, context = {}) {
            AnalyticsHelper.trackError(error, step, context);

            console.log('=== Builder Error ===');
            console.log('Step:', step);
            console.log('Error:', error);
            console.log('Context:', context);
            console.log('==================');
        }
    };

    // Add this after BuilderStorage definition
    const RecaptchaHelper = {
        execute: async function (action) {
            try {
                console.log('RecaptchaHelper: Starting execution for action:', action);

                // Wait for grecaptcha to be ready
                await new Promise((resolve) => {
                    if (typeof grecaptcha !== 'undefined' && typeof grecaptcha.execute !== 'undefined') {
                        resolve();
                    } else {
                        grecaptcha.ready(resolve);
                    }
                });

                // Use site key from WordPress
                const token = await grecaptcha.execute(craftrtech_recaptcha.site_key, { action: action });
                console.log('RecaptchaHelper: Token generated successfully for', action);

                if (!token) {
                    throw new Error('No token received from reCAPTCHA');
                }

                return token;
            } catch (error) {
                console.error('RecaptchaHelper error:', error);
                throw error;
            }
        }
    };

    const updateStepContent = async (newContent) => {
        const $content = $('#step-content');

        // Add transition class
        $content.addClass('content-transitioning');

        // Wait for fade out
        await new Promise(resolve => setTimeout(resolve, 300));

        // Update content
        $content.html(newContent);

        // Force browser reflow
        $content[0].offsetHeight;

        // Remove transition class to fade in
        $content.removeClass('content-transitioning');
    };

    // Move the changeStep function definition before any usage
    const changeStep = async function (stepNumber) {
        try {
            // Convert stepNumber to integer
            stepNumber = parseInt(stepNumber);

            // Show loading
            await updateStepContent(`
                    <div class="row align-items-center">
                        <div class="col-12 col-md-8 mx-auto">
                            <div class="card card-flush mb-15">
                                <div class="card-body text-center d-flex flex-column align-items-center justify-content-center">
                                    <span class="spinner-border text-primary" role="status">
                                        <span class="visually-hidden">Loading...</span>
                                    </span>
                                    <span class="card-label fw-bold text-gray-900 mt-7" style="font-size: 1.275rem;">
                                        Kickstarting some magic...
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                `);

            // Update storage
            BuilderStorage.set('currentStep', stepNumber);

            // Fetch the new step content
            const response = await $.ajax({
                url: craftrtech_ajax.ajax_url,
                type: 'POST',
                data: {
                    action: 'load_builder_step',
                    step: stepNumber,
                    popped: popped,
                    page_id: craftrtech_ajax.page_id,
                    _ajax_nonce: craftrtech_ajax.nonce
                }
            });

            if (response.success) {
                // Show new content with fade
                await updateStepContent(response.data.html);

                // Initialize Step 2 if needed
                if (stepNumber === 2) {
                    const savedIndustry = BuilderStorage.get('industry');
                    if (savedIndustry) {
                        $('.btn-check.category-box').each(function () {
                            const categoryKey = $(this).data('category-id');
                            const category = CategoryConfig[categoryKey];
                            if (category.title === savedIndustry) {
                                // Set the radio button as checked
                                $(this).prop('checked', true);
                                BuilderStorage.set('categoryKey', $(this).data('category-id'));

                                // Show the details section for mobile
                                const $label = $('label[for="' + $(this).attr('id') + '"]');
                                $label.find('.details').show();

                                // Update step-2-description for desktop
                                const categoryTitle = category.title;
                                const categoryDescription = category.description;

                                $('.step-2-description').html(`
                                        <div class="fs-2hx fw-bold text-gray-800 text-center mb-5 heading-font">${categoryTitle}</div>
                                        <p class="mb-5">${categoryDescription}</p>
                                        <button type="button" class="btn step-button btn-dark" id="proceed-to-3" data-step="3">Proceed<i class="ki-duotone ki-arrow-right fs-4 ms-1 me-0 text-white">
                                        <span class="path1"></span>
                                        <span class="path2"></span>
                                    </i></button>
                                    `);

                                $('#dottie-container').html(`
                                        <dotlottie-player
                                            src="${category.animationUrl}"
                                            background="transparent"
                                            speed="1"
                                            class="h-150px h-lg-200px"
                                            autoplay></dotlottie-player>
                                    `);

                                $('#radio_step_3_description_mobile').html(`<div class="d-flex flex-row">
                            ${category.icon}
                            <span class="d-block fw-semibold text-start">
                                <span class="text-gray-900 fw-bold d-block fs-3 heading-font" id="radio_step_3_title">${category.title}</span>
                                <span class="text-muted fw-semibold fs-6" id="radio_step_3_short_description">
                                    ${category.shortDescription}<br /><small>ex:<em>${category.examples}</em></small>
                                </span>
                            </span>
                        </div>
                        <div class="details text-start">
                            <p class="selling-point text-gray-900 mt-3" id="radio_step_3_description">${category.description}</p>
                            <button class="btn btn-primary w-100 mt-3 step-button" id="go-back-step-2-desktop" data-step="2"><i class="ki-duotone ki-arrow-left fs-4 ms-1 me-0 text-white">
                                        <span class="path1"></span>
                                        <span class="path2"></span>
                                    </i>Go Back</button>
                        </div>`);

                                // Smooth scroll to the selected option with header offset
                                const element = $('label[for="' + $(this).attr('id') + '"]')[0];
                                const header = document.getElementById('kt_app_header');
                                const offset = header ? header.offsetHeight + 15 : 100;

                                if (element) {
                                    const elementTop = element.getBoundingClientRect().top + window.pageYOffset;
                                    const scrollTo = elementTop - offset;
                                    window.scrollTo({
                                        top: scrollTo,
                                        behavior: 'smooth'
                                    });
                                }

                            }
                        });
                    }


                }

                // Initialize Step 3 if needed
                if (stepNumber === 3) {
                    const isDirectStep3 = $('#step3').data('direct-access') === true;

                    // Handle generate button visibility right after content is loaded
                    const siteUrl = BuilderStorage.get('siteEmulated');
                    const $generateButton = $('#generate-from-url');

                    if (siteUrl) {
                        $generateButton.removeClass('d-none').find('.url-display').text(siteUrl);
                    } else {
                        $generateButton.addClass('d-none');
                    }

                    // Only show category info if not direct step 3 access
                    if (!isDirectStep3) {
                        // Get saved industry data
                        const savedCategoryKey = BuilderStorage.get('categoryKey');
                        const category = CategoryConfig[savedCategoryKey];

                        if (category) {
                            $('.step-2-description').html(`
                                    <div class="fs-2hx fw-bold text-gray-800 text-center mb-5 heading-font">${category.title}</div>
                                    <p class="mb-5">${category.description}</p>
                                    
                                    <button class="btn step-button btn-dark" data-step="2"><i class="ki-duotone ki-arrow-left fs-4 ms-1 me-0 text-white">
                                        <span class="path1"></span>
                                        <span class="path2"></span>
                                    </i>Go Back</button>
                                `);

                            $('#dottie-container').html(`
                                    <dotlottie-player
                                        src="${category.animationUrl}"
                                        background="transparent"
                                        speed="1"
                                        class="h-150px h-lg-200px"
                                        autoplay></dotlottie-player>
                                `);

                            $('#radio_step_3_description_mobile').html(`<div class="d-flex flex-row">
                                    ${category.icon}
                                    <span class="d-block fw-semibold text-start">
                                        <span class="text-gray-900 fw-bold d-block fs-3 heading-font" id="radio_step_3_title">${category.title}</span>
                                        <span class="text-muted fw-semibold fs-6" id="radio_step_3_short_description">
                                            ${category.shortDescription}<br /><small>${category.examples}</small>
                                        </span>
                                    </span>
                                </div>
                                <div class="details text-start">
                                    <p class="selling-point text-gray-900 mt-3" id="radio_step_3_description">${category.description}</p>
                                    <button class="btn btn-dark btn-sm w-100 mt-3 step-button" id="go-back-step-2-mobile" data-step="2"><i class="ki-duotone ki-arrow-left fs-4 ms-1 me-0 text-white">
                                        <span class="path1"></span>
                                        <span class="path2"></span>
                                    </i>Go Back</button>
                                </div>`);

                        }
                    }

                    // Restore saved description
                    const savedDescription = BuilderStorage.get('description');
                    if (savedDescription) {
                        $('#business-input').val(savedDescription);
                    }

                    // Restore topics if they exist
                    const savedTopics = BuilderStorage.get('topics');
                    const selectedTopics = BuilderStorage.get('selectedTopics') || [];

                    if (savedTopics && savedTopics.length > 0) {
                        // Generate HTML for all topics
                        const topicsHtml = savedTopics.map(topic => {
                            const isSelected = selectedTopics.includes(topic);
                            return `<span class="btn me-5 mb-5 btn-sm topic ${isSelected ? 'btn-success selected' : 'btn-secondary'}" 
                                             data-topic="${topic}">${topic} <i class="ki-duotone ki-double-check fs-4 ms-1 me-0 ">
    <span class="path1"></span>
    <span class="path2"></span>
    </i></span>`;
                        }).join('');

                        $('#topics-container').html(topicsHtml);

                        // Enable/disable proceed button based on selection count
                        // if (selectedTopics.length >= 3 && selectedTopics.length <= 5) {
                        //     $('#step-3-proceed').prop('disabled', false);
                        // } else if (selectedTopics.length >= 5) {
                        //     showErrorPopup('You can select up to 5 topics.');
                        //     $('#step-3-proceed').prop('disabled', true);
                        // } else {
                        //     $('#step-3-proceed').prop('disabled', true);
                        // }
                    }

                    if (!isDirectStep3) {
                        // Smooth scroll to the selected option with header offset
                        const element = $('#business-description-card')[0];
                        const header = document.getElementById('kt_app_header');
                        const offset = header ? header.offsetHeight + 15 : 100;

                        const elementTop = element.getBoundingClientRect().top + window.pageYOffset;
                        const scrollTo = elementTop - offset;

                        window.scrollTo({
                            top: scrollTo,
                            behavior: 'smooth'
                        });
                    }

                    if (popped & step !== '4') {
                        $('#save-description').trigger('click');
                    }
                }

                // Initialize Step 4 if needed
                if (stepNumber === 4) {
                    const suggestedDomains = BuilderStorage.get('suggestedDomains');
                    const domainTldData = BuilderStorage.get('domainTldData');
                    const description = BuilderStorage.get('description');
                    const topics = BuilderStorage.get('topics') || [];
                    const selectedTopics = BuilderStorage.get('selectedTopics') || [];
                    const savedLength = BuilderStorage.get('desiredLength');
                    const savedLanguage = BuilderStorage.get('preferredLanguage');

                    // Populate the form with saved data
                    $('#business-description').val(description);

                    // Set saved length if it exists
                    if (savedLength) {
                        const parsedLength = parseInt(savedLength);
                        const parsedLengthLessOne = parsedLength - 1;
                        const parsedLengthPlusOne = parsedLength + 1;
                        $('#name-length').val(parsedLength);
                        const lengthRange = (parsedLengthLessOne) + "-" + (parsedLengthPlusOne);
                        $('#name-length-value').text(lengthRange);
                    }

                    // Set saved language if it exists
                    if (savedLanguage) {
                        $('#language').val(savedLanguage);
                    }

                    // Generate topics HTML using the same badge style as step-3
                    const topicsHtml = topics.map(topic => {
                        const isSelected = selectedTopics.includes(topic);
                        return `<span class="btn me-5 mb-5 btn-sm topic ${isSelected ? 'btn-success selected' : 'btn-secondary'}" 
                                                 data-topic="${topic}">${topic} <i class="ki-duotone ki-double-check fs-4 ms-1 me-0 ">
     <span class="path1"></span>
     <span class="path2"></span>
    </i></span>`;
                    }).join('');
                    $('#topics-container').html(topicsHtml);

                    // Display domains if available
                    if (suggestedDomains && suggestedDomains.length > 0) {
                        const domainsHtml = suggestedDomains.map(domainData =>
                            DomainCardHelper.generateCard(domainData)
                        ).join('');

                        $('#domain-ideas-container').html(domainsHtml);
                    }

                    // Handle name length range input
                    $('#name-length').on('input', function () {
                        const lengthRange = (parseInt(this.value) - 1) + "-" + (parseInt(this.value) + 1);
                        $('#name-length-value').text(lengthRange);
                    });

                    // Initialize sticky after content is loaded
                    KTSticky.createInstances();
                    // const stickyElement = document.querySelector("#step-4-form");
                    // if (stickyElement) {
                    //     const sticky = new KTSticky(stickyElement);
                    // }

                    // Handle regenerate button click
                    $('#regenerate-domains').on('click', async function () {
                        try {
                            // Get new values
                            const newDescription = $('#business-description').val();
                            const newSelectedTopics = BuilderStorage.get('selectedTopics');
                            const nameLength = $('#name-length').val();
                            const language = $('#language').val();
                            const industry = BuilderStorage.get('industry') || 'general';

                            // if (newSelectedTopics.length < 3 || newSelectedTopics.length > 5) {
                            //     showErrorPopup('Please select between 3 and 5 topics.');
                            //     return;
                            // }


                            $(this).prop('disabled', true);
                            $(this).text('Processing...');
                            $('#domain-ideas-container').html(`
                                    <div class="row align-items-center">
                                        <div class="col-12 col-md-8 mt-3 mx-auto">
                                            <div class="card card-flush mb-15">
                                                <div class="card-body text-center d-flex flex-column align-items-center justify-content-center">
                                                    <span class="spinner-border text-primary" role="status">
                                                        <span class="visually-hidden">Loading...</span>
                                                    </span>
                                                    <span class="card-label fw-bold text-gray-900 mt-7" style="font-size: 1.275rem;">
                                                        Loading new domains...
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                `);

                            // Store new values in localStorage
                            BuilderStorage.set('description', newDescription);
                            BuilderStorage.set('desiredLength', nameLength);
                            BuilderStorage.set('preferredLanguage', language);

                            window.dataLayer.push({
                                event: "Refine_biz_urls",
                                session_id: JSON.parse(localStorage.getItem('ad_parameters'))?.gclid || '',
                                click_id: "NA",
                                compete_input_url: BuilderStorage.get('siteEmulated'),
                                biz_type: BuilderStorage.get('industry'),
                                biz_desc: BuilderStorage.get('businessDescription'),
                                select_topics: BuilderStorage.get('selectedTopics').join(','),
                                non_select_topics: (BuilderStorage.get('topics') || []).filter(topic => !selectedTopics.includes(topic)).join(','),
                                word_length: BuilderStorage.get('desiredLength'),
                                url_language: BuilderStorage.get('preferredLanguage')
                            });

                            const token = await RecaptchaHelper.execute('generate_domains');

                            $.ajax({
                                url: craftrtech_ajax.ajax_url,
                                type: 'POST',
                                data: {
                                    action: 'craftrtech_domain_ideas',
                                    industry: industry,
                                    description: newDescription,
                                    selected_topics: newSelectedTopics,
                                    name_length: nameLength,
                                    language: language,
                                    recaptcha_token: token,
                                    _ajax_nonce: craftrtech_ajax.nonce
                                },
                                success: function (response) {
                                    if (response.success) {
                                        // Store new domain ideas and clear previous TLD data
                                        BuilderStorage.set('suggestedDomains', response.data.domain_ideas);
                                        BuilderStorage.set('domainTldData', {});

                                        // Re-render domains with new data
                                        const domainsHtml = response.data.domain_ideas.map(domainData =>
                                            DomainCardHelper.generateCard(domainData)
                                        ).join('');

                                        $('#domain-ideas-container').html(domainsHtml);
                                    } else {
                                        ErrorHandler.log('Step 4', response?.data?.message || 'Failed to generate domains');
                                        $('#domain-ideas-container').html('<p class="text-danger">Failed to generate domains. Please try again.</p>');
                                        showErrorPopup(response?.data?.message || 'Failed to generate domains');
                                    }
                                },
                                error: function (xhr, status, error) {
                                    ErrorHandler.log('Step 4', error, {
                                        status: status,
                                        xhr: xhr.responseText
                                    });

                                    $('#domain-ideas-container').html(UIHelper.generateErrorMessage());
                                    showErrorPopup('An error occurred while generating domains. Please try again.');
                                },
                                complete: function () {
                                    $('#regenerate-domains').prop('disabled', false).text('Refine');
                                    $('#closeFilters').trigger('click');
                                    $('#domain-ideas-container')[0].scrollIntoView({
                                        behavior: 'smooth',
                                        block: 'start'
                                    });
                                }
                            });
                        } catch (error) {
                            ErrorHandler.log('Step 4', error);
                            $('#domain-ideas-container').html('<p class="text-danger">An error occurred. Please try again.</p>');
                            showErrorPopup('An error occurred while processing your request. Please try again.');
                            $(this).prop('disabled', false).text('Refine');
                        }


                    });


                }
            } else {
                throw new Error(response.data.message || 'Failed to load step');
            }
        } catch (error) {
            console.error('Error changing step:', error);
            $('#step-content').html(UIHelper.generateErrorMessage('An error occurred while loading the step. Please try again.'));
        }
    };


    // Initialize storage on page load
    BuilderStorage.init();

    // Load the correct step on page load
    // const currentStep = BuilderStorage.get('currentStep');
    const phpStartStep = craftrtech_ajax.startStep;

    const step3Element = $('#step3');
    const isDirectAccess = step3Element.length > 0 && step3Element.data('direct-access') === true;



    // If phpStartStep is available from ajax object, use that
    if (phpStartStep) {
        BuilderStorage.set('currentStep', parseInt(phpStartStep));
        // changeStep(parseInt(phpStartStep));
    }
    // else if (currentStep) {
    //     // If no start step defined but we have a currentStep in storage, use that
    //     // changeStep(currentStep);
    // }

    if (step === '4') {
        BuilderStorage.set('currentStep', 4);

        updateStepContent(`
            <div class="row align-items-center">
                <div class="col-12 col-md-8 mx-auto">
                    <div class="card card-flush mb-15">
                        <div class="card-body text-center d-flex flex-column align-items-center justify-content-center">
                            <span class="spinner-border text-primary" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </span>
                            <span class="card-label fw-bold text-gray-900 mt-7" style="font-size: 1.275rem;">
                                Kickstarting some magic...
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        `);

        generateDomainIdeas('general', BuilderStorage.get('selectedTopics'))
            .then(() => {
                // Proceed to step 4
                changeStep(4);
            })
            .catch(error => {
                showErrorPopup(error.message);
                changeStep(3);
            });
    } else if (isDirectAccess) {
        $('#business-description').val(BuilderStorage.get('description'));
        BuilderStorage.set('currentStep', 3);

        if (BuilderStorage.get('description')?.trim() && popped) {
            const $saveButton = $('#save-description');
            if ($saveButton.length) {
                $saveButton.trigger('click');
            }
        }
    }

    // Load the correct step on page load
    const currentStep = BuilderStorage.get('currentStep');
    if (currentStep && currentStep !== 1 && !BuilderStorage.isFreshInit() && step !== '4') {
        changeStep(currentStep);
    }

    // Handle step changes for dynamically added elements
    document.addEventListener('click', function (e) {
        if (e.target.matches('.step-button')) {
            const stepNumber = e.target.dataset.step;

            // Check for specific button ID
            if (e.target.id === 'blue-ocean-btn') {
                AnalyticsHelper.trackBlueOceanBtnClick();
            } else if (e.target.id === 'proceed-to-3') {
                AnalyticsHelper.trackBusinessTypeSelection();
            } else if (e.target.id === 'go-back-step-2-mobile' || e.target.id === 'go-back-step-2-desktop') {
                AnalyticsHelper.trackGoBackPg3();
            } else if (e.target.id === 'go-back' || e.target.id === 'go-back-edit-description') {
                AnalyticsHelper.trackGoBackPg4();
            }

            changeStep(stepNumber);
        }
    });

    // Handle radio button selection for business categories
    $(document).on('change', '.category-box', function () {
        // BuilderStorage.clear();

        const categoryKey = $(this).data('category-id');
        const category = CategoryConfig[categoryKey];

        if (categoryKey !== BuilderStorage.get('categoryKey')) {
            BuilderStorage.reset();
        }


        const $label = $('label[for="' + $(this).attr('id') + '"]');

        // Store the selection including the categoryKey
        BuilderStorage.set('industry', category.title);
        BuilderStorage.set('industryDescription', category.description);
        BuilderStorage.set('categoryKey', categoryKey);

        // Show details for mobile view
        $('.details').hide();
        $label.find('.details').show();

        // Update step-2-description for desktop view
        $('.step-2-description').html(`
            <div class="fs-2hx fw-bold text-gray-800 text-center mb-5 heading-font">${category.title}</div>
            <p class="mb-5">${category.description}</p>
            <button type="button" class="btn step-button btn-dark" id="proceed-to-3" data-step="3">Proceed<i class="ki-duotone ki-arrow-right fs-4 ms-1 me-0 text-white">
                <span class="path1"></span>
                <span class="path2"></span>
            </i></button>
        `);

        $('#dottie-container').html(`
            <dotlottie-player
                src="${category.animationUrl}"
                background="transparent"
                speed="1"
                class="h-150px h-lg-200px"
                autoplay></dotlottie-player>
        `);

        // Smooth scroll to the selected option with header offset
        const element = $('label[for="' + $(this).attr('id') + '"]')[0];
        const header = document.getElementById('kt_app_header');
        const offset = header ? header.offsetHeight + 15 : 100;

        if (element) {
            const elementTop = element.getBoundingClientRect().top + window.pageYOffset;
            const scrollTo = elementTop - offset;
            window.scrollTo({
                top: scrollTo,
                behavior: 'smooth'
            });
        }
    });

    // Handle mobile proceed button click
    $(document).on('click', '.step-2-proceed', function () {
        AnalyticsHelper.trackBusinessTypeSelection();
        changeStep(3);
    });

    // Handle Step 1 submission
    $(document).on('click', '#step-1-proceed', async function (e) {
        e.preventDefault();

        let urlInput = $('#website-url-input').val().trim();

        // Validate URL
        const urlPattern = new RegExp(
            '^(https?:\\/\\/)?' +
            '((([a-zA-Z0-9\\-]+\\.)+[a-zA-Z]{2,})|' +
            'localhost|' +
            '\\d{1,3}(\\.\\d{1,3}){3})' +
            '(\\:\\d+)?(\\/[-a-zA-Z0-9@:%_+.~#?&//=]*)?$'
        );

        if (!urlInput || !urlPattern.test(urlInput)) {
            ErrorHandler.log('Step 1', 'Invalid URL', { url: urlInput });
            showErrorPopup('Looks like the URL you entered is invalid. Please enter a valid URL.');

            // GTM: Add error to dataLayer
            AnalyticsHelper.trackErrorOnCompeteBtn(urlInput, "Invalid URL Format");

            return;
        }

        // Sanitize URL by removing query parameters
        try {
            const urlObj = new URL(urlInput);
            urlInput = urlObj.origin + urlObj.pathname;
        } catch (e) {
            // If URL parsing fails, try adding https:// and parse again
            try {
                const urlObj = new URL('https://' + urlInput);
                urlInput = urlObj.origin + urlObj.pathname;

                // GTM: Add URL to dataLayer
                AnalyticsHelper.trackCompeteBtnClick(urlInput);
            } catch (e) {
                ErrorHandler.log('Step 1', 'URL Sanitization Failed', { url: urlInput });
                showErrorPopup('Unable to process the URL. Please try again.');
                return;
            }
        }

        // Store sanitized URL
        BuilderStorage.set('siteEmulated', urlInput);

        try {
            $(this).prop('disabled', true);
            $(this).text('Processing...');

            const token = await RecaptchaHelper.execute('classify_site');

            $.ajax({
                url: craftrtech_ajax.ajax_url,
                type: 'POST',
                data: {
                    action: 'craftrtech_get_site_type',
                    url: urlInput,
                    recaptcha_token: token,
                    _ajax_nonce: craftrtech_ajax.nonce
                },
                success: function (response) {
                    if (response.success) {
                        BuilderStorage.set('industry', response.data.classification);
                        changeStep(2);
                    } else {
                        ErrorHandler.log('Step 1', response?.data?.message || 'Failed to classify website', { url: urlInput });
                        showErrorPopup(response?.data?.message || 'Failed to classify website. Please try again.');

                        // GTM: Add error to dataLayer
                        AnalyticsHelper.trackErrorOnCompeteBtn(urlInput, response?.data?.message || 'Failed to classify website. Please try again.');
                    }
                },
                error: function (xhr, status, error) {
                    ErrorHandler.log('Step 1', error, {
                        url: urlInput,
                        status: status,
                        xhr: xhr.responseText
                    });
                    showErrorPopup('An error occurred while processing your request. Please try again.');

                    // GTM: Add error to dataLayer
                    AnalyticsHelper.trackErrorOnCompeteBtn(urlInput, 'An error occurred while processing your request.');
                },
                complete: function () {
                    $('#step-1-proceed').prop('disabled', false).text('Proceed');
                }
            });
        } catch (error) {
            ErrorHandler.log('Step 1', error, { url: urlInput });
            showErrorPopup('An error occurred while processing your request. Please try again.');

            // GTM: Add error to dataLayer
            AnalyticsHelper.trackErrorOnCompeteBtn(urlInput, 'An error occurred while processing your request.');

            $(this).prop('disabled', false).text('Proceed');
        }
    });

    // Handle business description submission and get topics
    $(document).on('click', '#save-description', async function (e) {
        const tag = this.tagName.toLowerCase();

        // Get and validate business description
        const businessDescription = $('#business-input').val().trim();
        const isDirectStep3 = $('#step3').data('direct-access') === true;
        const industry = isDirectStep3 ? 'general' : BuilderStorage.get('industry');

        if (!businessDescription) {
            e.preventDefault();
            ErrorHandler.log('Step 3', 'Empty description', { industry });
            showErrorPopup('Please enter a business description.');
            return;
        }

        // Add character limit validation
        if (businessDescription.length > 300) {
            e.preventDefault();
            ErrorHandler.log('Step 3', 'Description too long', {
                industry,
                length: businessDescription.length
            });
            showErrorPopup('Business description must be 300 characters or less.');
            return;
        }

        lastSavedDescription = businessDescription;

        // Store description
        BuilderStorage.set('description', businessDescription);

        try {
            $(this).prop('disabled', true);
            $(this).addClass('disabled');
            $(this).text('Processing...');

            const token = await RecaptchaHelper.execute('generate_topics');

            AnalyticsHelper.trackBizDescConfirm();

            $.ajax({
                url: craftrtech_ajax.ajax_url,
                type: 'POST',
                data: {
                    action: 'craftrtech_get_tags',
                    business_description: businessDescription,
                    industry: industry,
                    recaptcha_token: token,
                    _ajax_nonce: craftrtech_ajax.nonce
                },
                success: function (response) {
                    if (response.success) {
                        // Store topics in localStorage
                        const topicsArray = response.data.topics.split(',').map(topic => topic.trim());
                        BuilderStorage.set('topics', topicsArray);

                        // Display topics
                        const topicsHtml = topicsArray.map(topic =>
                            `<span class="btn me-5 mb-5 btn-sm topic btn-secondary" data-topic="${topic}">${topic}<i class="ki-duotone ki-double-check fs-4 ms-1 me-0">
 <span class="path1"></span>
 <span class="path2"></span>
</i></span>`
                        ).join('');

                        $('#topics-container').html(topicsHtml);

                        const topicsCard = document.getElementById('topics-card');
                        if (topicsCard) {
                            topicsCard.scrollIntoView({
                                behavior: 'smooth',
                                block: 'start'
                            });
                        }

                        // Change button text back to "Save Description" while keeping it disabled
                        $('#save-description').text('Save Description');

                        if (step === '4') {
                            BuilderStorage.set('currentStep', 4);

                            updateStepContent(`
            <div class="row align-items-center">
                <div class="col-12 col-md-8 mx-auto">
                    <div class="card card-flush mb-15">
                        <div class="card-body text-center d-flex flex-column align-items-center justify-content-center">
                            <span class="spinner-border text-primary" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </span>
                            <span class="card-label fw-bold text-gray-900 mt-7" style="font-size: 1.275rem;">
                                Kickstarting some magic...
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        `);

                            generateDomainIdeas('general', BuilderStorage.get('selectedTopics'))
                                .then(() => {
                                    // Proceed to step 4
                                    changeStep(4);
                                })
                                .catch(error => {
                                    showErrorPopup(error.message);
                                    changeStep(3);
                                });
                        }
                    } else {
                        ErrorHandler.log('Step 3', response?.data?.message || 'Failed to generate topics', {
                            industry: industry,
                            description: businessDescription
                        });
                        $('#topics-container').html(UIHelper.generateErrorMessage('Failed to generate topics. Please try to improve your business description and try again.'));
                        showErrorPopup(response?.data?.message || 'Failed to generate topics. Please try again.');
                        // Re-enable button on error
                        $('#save-description').prop('disabled', false).removeClass('disabled').text('Save Description');
                    }


                    if (craftrtech_ajax.domain_builder &&
                        craftrtech_ajax.domain_builder.enable_popunder &&
                        !hasPopunderCookie() && !popped) {
                        setPopunderCookie();
                        // Push analytics data
                        AnalyticsHelper.trackNameOBCPop();

                        let finalUrl = craftrtech_ajax.domain_builder.redirect_url || 'https://www.namecheap.com';
                        try {
                            const adParams = JSON.parse(localStorage.getItem('ad_parameters'));
                            if (adParams?.gclid) {
                                // Add gclid to URL, handling both cases where URL might already have parameters
                                finalUrl += (finalUrl.includes('?') ? '&' : '?') + `gclid=${adParams.gclid}`;
                            }
                        } catch (error) {
                            console.error('Error getting gclid:', error);
                        }

                        window.open(finalUrl, '_self');
                    }
                },
                error: function (xhr, status, error) {
                    ErrorHandler.log('Step 3', error, {
                        industry: industry,
                        description: businessDescription,
                        status: status,
                        xhr: xhr.responseText
                    });
                    $('#topics-container').html('<p class="text-danger">An error occurred. Please try again.</p>');
                    showErrorPopup('An error occurred while generating topics. Please try again.');
                    // Re-enable button on error
                    $('#save-description').prop('disabled', false).removeClass('disabled').text('Save Description');
                }
            });
        } catch (error) {
            ErrorHandler.log('Step 3', error, {
                industry: industry,
                description: businessDescription
            });
            $('#topics-container').html('<p class="text-danger">An error occurred. Please try again.</p>');
            showErrorPopup('An error occurred while processing your request. Please try again.');
            // Re-enable button on error
            $('#save-description').prop('disabled', false).removeClass('disabled').text('Save Description');
        }
    });

    // Handle topic selection
    $(document).on('click', '.topic', function () {
        // If trying to select a 6th topic, do nothing
        console.log($(this).hasClass('selected'));
        console.log($('.topic.selected').length >= 5);
        // if (!$(this).hasClass('selected') && $('.topic.selected').length >= 5) {
        //     showErrorPopup('You can select up to 5 topics.');
        //     return;
        // }

        $(this).toggleClass('btn-secondary');
        $(this).toggleClass('btn-success');
        $(this).toggleClass('selected');

        // Get all selected topics
        const selectedTopics = $('.topic.selected').map(function () {
            return $(this).data('topic');
        }).get();

        // Store selected topics
        BuilderStorage.set('selectedTopics', selectedTopics);

        // Enable/disable proceed button based on selection count
        // if (selectedTopics.length > 0 && selectedTopics.length <= 5) {
        //     $('#step-3-proceed').prop('disabled', false);
        // } else {
        //     $('#step-3-proceed').prop('disabled', true);
        // }
        // $('#step-3-proceed').prop('disabled', true);
    });

    // Handle Step 3 submission
    $(document).on('click', '#step-3-proceed', async function (e) {
        e.preventDefault();

        const isDirectStep3 = $('#step3').data('direct-access') === true;
        const industry = isDirectStep3 ? 'general' : BuilderStorage.get('industry');
        const selectedTopics = BuilderStorage.get('selectedTopics');

        if (!isDirectStep3 && !industry) {
            ErrorHandler.log('Step 3', 'No industry selected');
            showErrorPopup('Please select an industry before proceeding.');
            return;
        }

        // if (!selectedTopics || selectedTopics.length < 3 || selectedTopics.length > 5) {
        //     ErrorHandler.log('Step 3', 'Invalid input', {
        //         industry: industry,
        //         selectedTopics: selectedTopics
        //     });
        //     showErrorPopup('Please select 3-5 topics before proceeding.');
        //     return;
        // }

        try {
            $(this).prop('disabled', true);
            $(this).text('Processing...');

            await generateDomainIdeas(industry, selectedTopics);

            // Proceed to step 4
            changeStep(4);
        } catch (error) {
            showErrorPopup(error.message);
        } finally {
            $(this).prop('disabled', false).text('Proceed');
        }
    });

    // Handle clear storage button click
    $(document).on('click', '#clear-local-storage', function () {
        BuilderStorage.clear();
    });

    $(document).on('click', '#toggleFilters', function () {
        $('.mobile-filters').addClass('show');
        // $('body').toggleClass('overflow-hidden');
    });

    $(document).on('click', '#closeFilters, #go-back, #go-back-edit-description', function () {
        $('.mobile-filters').removeClass('show');
        // $('body').removeClass('overflow-hidden');
    });

    // Add event listener for business-input changes
    let lastSavedDescription = BuilderStorage.get('description') || '';
    $(document).on('input', '#business-input', function () {
        const currentDescription = $(this).val().trim();
        if (currentDescription !== lastSavedDescription) {
            $('#save-description').prop('disabled', false).removeClass('disabled').text('Save Description');
        }
    });



    function showErrorPopup(message) {
        Swal.fire({
            title: 'Error',
            text: message,
            icon: 'error',
            buttonsStyling: false,
            confirmButtonText: "Ok, got it!",
            heightAuto: false,
            customClass: {
                confirmButton: "btn btn-light",
                container: 'swal-mobile-fix'
            }
        });
    }

    const CategoryConfig = {
        ecommerce: {
            categoryId: 'ecommerce',
            title: 'Ecommerce',
            icon: '<i class="ki-duotone ki-basket fs-4x me-4"><span class="path1"></span><span class="path2"></span></i>',
            shortDescription: 'Turn Your Products into Profit',
            examples: 'Shopify, Amazon FBA, Etsy, Digital Products',
            animationUrl: 'https://lottie.host/3d0397c7-c13d-4f6b-b96f-3924579485c2/xlfQfcpWHU.lottie',
            description: "Ready to join the booming world of online retail? Whether you're selling physical products, digital downloads, or both, we'll help you build a thriving online store that sells 24/7. Let's create your roadmap to ecommerce success!"
        },
        online_service: {
            categoryId: 'online_service',
            title: 'Online Service',
            icon: '<i class="ki-duotone ki-rocket fs-4x me-4"><span class="path1"></span><span class="path2"></span></i>',
            shortDescription: 'Share Your Expertise Globally',
            examples: 'Consulting, Marketing, Legal, Design, Coaching',
            animationUrl: 'https://lottie.host/d65beb85-d4a2-4339-ad55-2afe210061f2/N65D4Hp6UF.lottie',
            description: "Transform your skills into a profitable online service business! Work from anywhere, reach clients worldwide, and build a business that scales. We'll show you exactly how to package and sell your expertise online."
        },
        hybrid_business: {
            categoryId: 'hybrid_business',
            title: 'Hybrid',
            icon: '<i class="ki-duotone ki-shop fs-4x me-4"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span><span class="path5"></span></i>',
            shortDescription: 'Best of Both Worlds',
            examples: 'Restaurants, Salons, Fitness Studios, Local Services',
            animationUrl: 'https://lottie.host/73bfb652-7fa5-449b-a464-7d52efeb2382/SqJT7x871y.lottie',
            description: "Combine the power of local presence with online reach! Perfect for businesses that want to dominate both physically and digitally. We'll help you create a winning strategy that brings customers through both your physical and virtual doors."
        },
        apps_saas: {
            categoryId: 'apps_saas',
            title: 'Apps and SAAS',
            icon: '<i class="ki-duotone ki-code fs-4x me-4"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span></i>',
            shortDescription: 'Create the Next Big Thing',
            examples: 'Mobile Apps, Web Platforms, Business Software',
            animationUrl: 'https://lottie.host/5e2c225b-ff44-45eb-9ced-42254e4578ac/RyGzwZ6mud.lottie',
            description: "Dream of building the next game-changing app or software? Turn your tech vision into a scalable SaaS business! We'll guide you through launching and growing your software solution from idea to profitable platform."
        },
        content_creation: {
            categoryId: 'content_creation',
            title: 'Content',
            icon: '<i class="ki-duotone ki-youtube fs-4x me-4"><span class="path1"></span><span class="path2"></span></i>',
            shortDescription: 'Monetize Your Creativity',
            examples: 'YouTube, Podcasting, Blogging, Social Media',
            animationUrl: 'https://lottie.host/1a784692-d4f9-4e6a-8023-5578dbf7fd84/FQCnj9RGbU.lottie',
            description: "Turn your passion into profit through content creation! Whether you're into video, audio, or written content, we'll show you how to build and monetize an engaged audience. Start earning from doing what you love!"
        },
        asset_capital: {
            categoryId: 'asset_capital',
            title: 'Asset and Capital',
            icon: '<i class="ki-duotone ki-home-1 fs-4x me-4"><span class="path1"></span><span class="path2"></span></i>',
            shortDescription: 'Build Lasting Wealth',
            examples: 'Real Estate, Vehicle Rentals, Equipment Leasing',
            animationUrl: 'https://lottie.host/09126df9-1e44-48bc-a461-6be21f31d87b/gcMWHHoUrJ.lottie',
            description: "Create passive income streams through smart asset investments! Whether it's property, vehicles, or equipment, we'll help you build a profitable portfolio that generates steady returns. Start building your empire today!"
        }
    };

    // UI Helper Object
    const UIHelper = {
        generateErrorMessage: function (message = 'An error occurred. Please try again.') {
            return `
                <div class="col-12">
                    <div class="d-flex align-items-center rounded py-5 px-5 bg-light-danger">
                        <i class="ki-duotone ki-shield-cross fs-3x text-danger me-5">
                            <span class="path1"></span>
                            <span class="path2"></span>
                            <span class="path3"></span>
                        </i>
                        <div class="text-gray-700 fw-bold fs-6">
                            ${message}
                        </div>
                    </div>
                </div>
            `;
        }
    };

    // Domain HTML Helper
    const DomainCardHelper = {
        generateCard: function (domainData) {
            return `
                <div class="col-12 col-lg-4 domain-card">
                    <div class="card card-flush" data-domain="${domainData}">
                        <!--begin::Header-->
                        <div class="card-header pt-5">
                            <!--begin::Title-->
                            <h3 class="card-title text-gray-800 fw-bold">${domainData}</h3>
                            <!--end::Title-->
                        </div>
                        <!--end::Header-->

                        <!--begin::Body-->
                        <div class="card-body pt-5">
                            ${this.generateDomainLink(domainData, 'au')}
                            <div class="separator separator-dashed my-3"></div>
                            ${this.generateDomainLink(domainData, 'com.au')}
                            <div class="separator separator-dashed my-3"></div>
                            ${this.generateDomainLink(domainData, 'com')}
                            <div class="separator separator-dashed my-3"></div>
                            ${this.generateDomainLink(domainData, 'org')}
                            <div class="separator separator-dashed my-3"></div>
                            ${this.generateDomainLink(domainData, 'ai')}
                            <div class="separator separator-dashed my-3"></div>
                            ${this.generateDomainLink(domainData, 'online')}
                        </div>
                        <!--end::Body-->
                    </div>
                </div>
            `;
        },

        generateDomainLink: function (domain, tld) {
            const redirectSearchUrl = craftrtech_ajax.domain_builder.search_redirect_url || 'https://www.crazydomains.com.au/domain-names/search/?domain={domain}&promo[]=VJBB1CN2&promo[]=PNLPMKJS';
            const fullDomain = `${domain}.${tld}`.toLowerCase();
            let finalUrl = redirectSearchUrl.replace('{domain}', fullDomain);

            // Get gclid from localStorage if available
            try {
                const adParams = JSON.parse(localStorage.getItem('ad_parameters'));
                if (adParams?.gclid) {
                    // Add gclid to URL, handling both cases where URL might already have parameters
                    finalUrl += (finalUrl.includes('?') ? '&' : '?') + `gclid=${adParams.gclid}`;
                }
            } catch (error) {
                console.error('Error getting gclid:', error);
            }

            return `
                <!--begin::Item-->
                <div class="d-flex flex-stack">
                    <!--begin::Section-->
                    <a href="${finalUrl}" rel="nofollow" target="_blank" 
                       class="text-primary fw-semibold fs-6 me-2 d-flex flex-row w-100 outbound-link">
                       <i class="ki-duotone ki-check-square fs-2 text-success me-2">
                        <span class="path1"></span>
                        <span class="path2"></span>
                        </i>
                        ${fullDomain}
                        <i class="ki-duotone ki-exit-right-corner fs-2 ms-auto">
                            <span class="path1"></span>
                            <span class="path2"></span>
                        </i>
                    </a>
                    <!--end::Section-->
                </div>
                <!--end::Item-->
            `;
        }
    };

    // Make sure Swal is available globally
    window.Swal = Swal;

    // Initialize SweetAlert2 with mobile-friendly defaults
    window.Toast = Swal.mixin({
        target: 'body',
        customClass: {
            container: 'position-fixed'
        },
        toast: true,
        position: 'bottom',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true
    });

    // Add iOS cursor fix
    if (navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
        document.body.style.cursor = 'pointer';
    }

    // Add this after the existing business description handler
    $(document).on('click', '#generate-from-url', async function (e) {
        e.preventDefault();

        // Get the stored URL
        const siteUrl = BuilderStorage.get('siteEmulated');

        if (!siteUrl) {
            ErrorHandler.log('Step 3', 'No URL available for description generation');
            showErrorPopup('No website URL found. Please start from Step 1.');
            return;
        }

        try {
            // Disable button and show loading state
            $(this).prop('disabled', true);
            const originalButtonText = $(this).text();
            $(this).text('Generating...');

            const token = await RecaptchaHelper.execute('generate_description');

            $.ajax({
                url: craftrtech_ajax.ajax_url,
                type: 'POST',
                data: {
                    action: 'craftrtech_generate_description',
                    url: siteUrl,
                    recaptcha_token: token,
                    _ajax_nonce: craftrtech_ajax.nonce
                },
                success: function (response) {
                    if (response.success) {
                        // Update the textarea with the generated description
                        $('#business-input').val(response.data.description);

                        AnalyticsHelper.trackAIBizSelected(response.data.description);


                        // Optional: Trigger save description to get topics right away
                        // $('#save-description').trigger('click');
                    } else {
                        ErrorHandler.log('Step 3', response?.data?.message || 'Failed to generate description', { url: siteUrl });
                        showErrorPopup(response?.data?.message || 'Failed to generate description. Please try again.');
                    }
                },
                error: function (xhr, status, error) {
                    ErrorHandler.log('Step 3', error, {
                        url: siteUrl,
                        status: status,
                        xhr: xhr.responseText
                    });
                    showErrorPopup('An error occurred while generating the description. Please try again.');
                },
                complete: function () {
                    // Reset button state
                    $('#generate-from-url').prop('disabled', false).text(originalButtonText);
                }
            });
        } catch (error) {
            ErrorHandler.log('Step 3', error, { url: siteUrl });
            showErrorPopup('An error occurred while processing your request. Please try again.');
            $(this).prop('disabled', false).text(originalButtonText);
        }
    });

    // Add this method near other helper objects/methods
    const AnalyticsHelper = {
        trackBusinessTypeSelection: function () {
            window.dataLayer.push({
                event: "Biz_Type_Selected",
                session_id: JSON.parse(localStorage.getItem('ad_parameters'))?.gclid || '',
                click_id: "NA",
                compete_input_url: BuilderStorage.get('siteEmulated'),
                biz_type: BuilderStorage.get('industry')
            });
        },
        trackError: function (errorMessage, step, context) {
            window.dataLayer.push({
                event: "tracked_error",
                session_id: JSON.parse(localStorage.getItem('ad_parameters'))?.gclid || '',
                tracked_error_message: errorMessage,
                tracked_error_step: step,
                tracked_error_context: context,
                tracked_error_url: window.location.href
            });
        },
        trackOutboundClick: function (outboundUrl) {
            try {
                const sessionId = JSON.parse(localStorage.getItem('ad_parameters'))?.gclid || '';
                const siteUrl = BuilderStorage.get('siteEmulated') || 'NA';
                const bizType = BuilderStorage.get('industry') || 'NA';
                const bizDesc = BuilderStorage.get('description') || 'NA';
                const selectedTopics = BuilderStorage.get('selectedTopics') || [];
                const allTopics = BuilderStorage.get('topics') || [];
                const wordLength = BuilderStorage.get('desiredLength') || 'NA';
                const urlLanguage = BuilderStorage.get('preferredLanguage') || 'NA';

                const nonSelectedTopics = allTopics.filter(topic => !selectedTopics.includes(topic));

                window.dataLayer.push({
                    event: "Obclick_URL_Select",
                    session_id: sessionId,
                    click_id: "NA",
                    compete_input_url: siteUrl,
                    biz_type: bizType,
                    biz_desc: bizDesc,
                    select_topics: selectedTopics.join(','),
                    non_select_topics: nonSelectedTopics.join(','),
                    word_length: wordLength,
                    url_language: urlLanguage,
                    obclick_url_select: outboundUrl
                });
            } catch (error) {
                console.error('Analytics Error:', error);
            }
        },
        trackRefineBizUrls: function () {
            window.dataLayer.push({
                event: "Refine_biz_urls",
                session_id: JSON.parse(localStorage.getItem('ad_parameters'))?.gclid || '',
                click_id: "NA",
                compete_input_url: BuilderStorage.get('siteEmulated'),
                biz_type: BuilderStorage.get('industry'),
                biz_desc: BuilderStorage.get('businessDescription'),
                select_topics: BuilderStorage.get('selectedTopics').join(','),
                non_select_topics: (BuilderStorage.get('topics') || []).filter(topic => !selectedTopics.includes(topic)).join(','),
                word_length: BuilderStorage.get('desiredLength'),
                url_language: BuilderStorage.get('preferredLanguage')
            });
        },
        trackBizDescConfirm: function () {
            window.dataLayer.push({
                event: "Biz_Desc_Confirm",
                session_id: JSON.parse(localStorage.getItem('ad_parameters'))?.gclid || '',
                click_id: "NA",
                compete_input_url: BuilderStorage.get('siteEmulated'),
                biz_type: BuilderStorage.get('industry'),
                ai_biz_desc: BuilderStorage.get('businessDescription'),
                biz_desc: BuilderStorage.get('businessDescription')
            });
        },
        trackBizTopicsSelected: function (selectedTopics) {
            window.dataLayer.push({
                event: "Biz_Topics_Selected",
                session_id: JSON.parse(localStorage.getItem('ad_parameters'))?.gclid || '',
                click_id: "NA",
                compete_input_url: BuilderStorage.get('siteEmulated'),
                biz_type: BuilderStorage.get('industry'),
                ai_biz_desc: BuilderStorage.get('businessDescription'),
                biz_desc: BuilderStorage.get('businessDescription'),
                select_topics: selectedTopics.join(','),
                non_select_topics: (BuilderStorage.get('topics') || []).filter(topic => !selectedTopics.includes(topic)).join(',')
            });
        },
        trackAIBizSelected: function (description) {
            window.dataLayer.push({
                event: "AI_Biz_Selected",
                session_id: JSON.parse(localStorage.getItem('ad_parameters'))?.gclid || '',
                click_id: "NA",
                compete_input_url: BuilderStorage.get('siteEmulated'),
                biz_type: BuilderStorage.get('industry'),
                ai_biz_desc: description
            });
        },
        trackNameOBCPop: function () {
            const sessionId = JSON.parse(localStorage.getItem('ad_parameters'))?.gclid || '';
            const siteUrl = BuilderStorage.get('siteEmulated') || 'NA';
            const bizType = BuilderStorage.get('industry') || 'NA';
            const bizDesc = BuilderStorage.get('description') || 'NA';
            const selectedTopics = BuilderStorage.get('selectedTopics') || [];
            const allTopics = BuilderStorage.get('topics') || [];

            const nonSelectedTopics = allTopics.filter(topic => !selectedTopics.includes(topic));

            window.dataLayer.push({
                event: "name_obc_pop",
                session_id: sessionId,
                click_id: "NA",
                compete_input_url: siteUrl,
                biz_type: bizType,
                ai_biz_desc: bizDesc,
                biz_desc: bizDesc,
                select_topics: selectedTopics.join(','),
                non_select_topics: nonSelectedTopics.join(','),
                offer_partner: craftrtech_ajax.domain_builder.redirect_url
            });
        },
        trackErrorOnCompeteBtn: function (urlInput, errorMessage) {
            window.dataLayer.push({
                event: "Error_on_Compete_btn_click",
                session_id: JSON.parse(localStorage.getItem('ad_parameters'))?.gclid || '',
                compete_input_url: urlInput,
                click_id: "NA",
                error_message: errorMessage
            });
        },
        trackCompeteBtnClick: function (urlInput) {
            window.dataLayer.push({
                event: "Compete_btn_click",
                session_id: JSON.parse(localStorage.getItem('ad_parameters'))?.gclid || '',
                click_id: "NA",
                compete_input_url: urlInput
            });
        },
        trackBlueOceanBtnClick: function () {
            window.dataLayer.push({
                event: "BlueOcean_btn_click",
                session_id: JSON.parse(localStorage.getItem('ad_parameters'))?.gclid || '',
                click_id: "NA"
            });
        },
        trackGoBackPg3: function () {
            window.dataLayer.push({
                event: "go_back_pg3",
                session_id: JSON.parse(localStorage.getItem('ad_parameters'))?.gclid || '',
                click_id: "NA"
            });
        },
        trackGoBackPg4: function () {
            window.dataLayer.push({
                event: "go_back_pg4",
                session_id: JSON.parse(localStorage.getItem('ad_parameters'))?.gclid || '',
                click_id: "NA"
            });
        }
    };

    // Add the event listener using event delegation
    $(document).on('click', 'a.outbound-link', function (e) {
        // Get the outbound URL
        const outboundUrl = $(this).attr('href');

        // Track the click
        AnalyticsHelper.trackOutboundClick(outboundUrl);

        // Don't prevent default - let the link work normally
    });


});






// Domain Card HTML Backup
/* <div class="col-12 col-lg-4 domain-card ${loadedClass}" data-domain="${domainData}">
                                    <div class="card bg-light h-100 border-0">
                                        <div class="card-body text-center">
                                            <h5 class="card-title">${domainData}</h5>
                                            <div class="tld-options">
                                                ${tldOptionsHtml}
                                            </div>
                                        </div>
                                    </div>
                                </div> */

// <div class="col-12 col-lg-4 domain-card tlds-not-loaded" data-domain="${domainData}">
//     <div class="card bg-light h-100 border-0">
//         <div class="card-body text-center">
//             <h5 class="card-title">${domainData}</h5>
//             <div class="tld-options">
//                 <button class="btn btn-light check-availability-btn">Check Availability</button>
//             </div>
//         </div>
//     </div>
// </div> -->